import { ITutorRequest } from '@wot/typings';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import tutorRequestsApi from '../../../api/tutor-requests';
import { TableBody, TableHeading, TableHeadingCol, TableRow } from '../../../components/Table';
import { TableRowItem } from './components/TableRowItem';
import TutorProfilePage from './components/TutorProfile';
import TutorReviewProgress from './components/TutorReviewProgress';

export const statuses = {
  'under-review': 'Under Review',
  revision: 'Requires Revision',
  rejected: 'Rejected',
  'gen-agreement': 'Generate Agreement',
  'rev-agreement': 'Tutor Decision'
};

export default function TutorRequestPage() {
  const [tutor, setTutor] = useState<ITutorRequest>();
  const { tutor_id } = useParams();

  useEffect(() => {
    if (tutor_id) {
      tutorRequestsApi.getById(tutor_id).then((data) => setTutor(data));
    }
  }, [tutor_id]);

  if (!tutor) {
    return <p>Loading...</p>;
  }

  return (
    <div className="w-full flex flex-col gap-4 p-2 grow">
      <h1 className="text-xl font-semibold">{tutor.personal.data.name}&apos;s Profile</h1>
      <table className="w-full h-full table-auto">
        <TableHeading>
          <TableRow>
            <TableHeadingCol label="Date" />
            <TableHeadingCol label="Req ID" />
            <TableHeadingCol label="NAME" />
            <TableHeadingCol label="EMAIL" />
            <TableHeadingCol label="PHONE NO." />
            <TableHeadingCol label="CATEGORY" />
            <TableHeadingCol label="STATUS" />
          </TableRow>
        </TableHeading>
        <TableBody>
          <>
            <TableRow>
              <>
                <TableRowItem tutor={tutor} setTutor={setTutor} />
              </>
            </TableRow>
          </>
        </TableBody>
      </table>
      <TutorReviewProgress tutor={tutor} />
      <TutorProfilePage mode="edit" isRequest={true} tutor={tutor} setTutor={setTutor} />
    </div>
  );
}
